import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function GoRedirect() {
  const { slug } = useParams();
  const { search } = useLocation();
  useEffect(() => {
    const qs = new URLSearchParams(search);
    qs.set("fmt", "json");
    api.get(`/go/${encodeURIComponent(slug)}?${qs.toString()}`)
      .then((r) => window.location.replace(r.data.url))
      .catch(() => window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/go/${encodeURIComponent(slug)}${search}`));
  }, [slug, search]);
  return <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground" data-testid="go-redirect">Weiterleitung…</div>;
}
